import * as React from 'react';

const Lu24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#4BA0D9", d: "M3 15a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-1H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M3 14h18v-4H3z" }), /* @__PURE__ */ React.createElement("path", { fill: "#DC1C37", d: "M3 10h18V9a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3z" }));
Lu24.Size = 24;
Lu24.Title = "Lu";

export { Lu24 as default };
